/// <amd-module name="Repos/Views/Import/ProtocolHandler" />
import { ObservableArray } from "VSS/Core/Observable";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export interface IProtocolHandler {
    downloadUrl: string;
    ideType: number;
    name: string;
    protocolHandlerUrl: string;
    supportedPlatforms: string[];
}

export interface IGitProtocolHandlerService extends IVssService {
    getHandlers: () => ObservableArray<IProtocolHandler>;
}

class ProtocolHandlerService extends VssService implements IGitProtocolHandlerService {
    private protocolHandlers = new ObservableArray<IProtocolHandler>();

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);

        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        contributionService.getDataAsync<IProtocolHandler[]>("ms.vss-code-web.protocol-handler-data-provider2").then(protocolHandlers => {
            if (protocolHandlers) {
                this.protocolHandlers.push(...protocolHandlers);
            }
        });
    }

    public getHandlers(): ObservableArray<IProtocolHandler> {
        return this.protocolHandlers;
    }
}

Services.add("IGitProtocolHandlerService", { serviceFactory: ProtocolHandlerService });
